import React from 'react';

export const formatMoney = (value: any) => {
  const num = Number(value || 0);
  if (Math.abs(num) >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(2)}B`;
  if (Math.abs(num) >= 1_000_000) return `${(num / 1_000_000).toFixed(2)}M`;
  if (Math.abs(num) >= 1_000) return `${(num / 1_000).toFixed(2)}K`;
  return num.toLocaleString();
};

export const BieMoney: React.FC<{ value: any; suffix?: string }> = ({ value, suffix = ' FCFA' }) => {
  return <>{formatMoney(value)}{suffix}</>;
};
